import { render, staticRenderFns } from "./ContactForm.html?vue&type=template&id=d1dd5352&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./ContactForm.scss?vue&type=style&index=0&id=d1dd5352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dd5352",
  null
  
)

export default component.exports